import { BASE_URL_EU, BASE_URL_US } from '@/config';
import { RegionConfig, ResolvedRegion } from './models';

// Feature flag to enable/disable multi-region support
// Set to true to enable region selector and auto-detection
export const MULTI_REGION_ENABLED = true;

export const REGION_CONFIGS: Record<ResolvedRegion, RegionConfig> = {
    eu: {
        apiBaseUrl: BASE_URL_EU,
        socketBaseUrl: BASE_URL_EU
    },
    us: {
        apiBaseUrl: BASE_URL_US,
        socketBaseUrl: BASE_URL_US
    }
};

export const REGION_STORAGE_KEY = 'safepoint_region';
export const GEO_IP_CACHE_KEY = 'safepoint_geo_ip_region';
export const GEO_IP_CACHE_EXPIRY_KEY = 'safepoint_geo_ip_expiry';
export const GEO_IP_CACHE_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

// Americas timezones that should use US region
// Includes additional Pacific/Atlantic timezones for Americas territories
export const AMERICAS_TIMEZONES: Set<string> = new Set([
    // US Pacific
    'Pacific/Honolulu',
    // Ecuador
    'Pacific/Galapagos',
    // Chile
    'Pacific/Easter',
    // Atlantic territories
    'Atlantic/Bermuda'
]);

// Countries that should use US region (Americas)
export const US_REGION_COUNTRIES = [
    // North America
    'US',
    'CA',
    'MX',
    // South America
    'AR',
    'BO',
    'BR',
    'CL',
    'CO',
    'EC',
    'GY',
    'PY',
    'PE',
    'SR',
    'UY',
    'VE',
    // Central America
    'BZ',
    'CR',
    'SV',
    'GT',
    'HN',
    'NI',
    'PA',
    // Caribbean
    'CU',
    'DO',
    'HT',
    'JM',
    'PR',
    'TT'
];
